import { doodBlockConfig, propertyValue } from './dood-block-config';
import {
  buildOrderedBlockDescriptor,
  type DescriptorFieldOrderItem,
} from './descriptor-field-order';
import type { IBlockDescriptor } from './descriptor';

export const PATCHOOSEAMOUNTPAGE_LEGACY_FIELD_ORDER = [
  { type: 'groupedFields', handle: 'tip_amounts', fields: ["choice1Amount","choice1Unit","choice2Amount","choice2Unit","choice3Amount","choice3Unit"] }
] as const satisfies readonly DescriptorFieldOrderItem[];

const tipUnitChoices = [
  {
    value: "currency",
    label: "pages.blocks.pat-choose-amount-page.unit.options.currency",
  },
  {
    value: "percent",
    label: "pages.blocks.pat-choose-amount-page.unit.options.percent",
  },
] as const;

const {
  patChooseAmountPageDescriptor: _generatedPatChooseAmountPageDescriptor,
  patChooseAmountPageBlocDefinition,
  patChooseAmountPageDashboardLayout,
  patChooseAmountPageConfig,
  patChooseAmountPageResolveConfig,
  patChooseAmountPageProperties,
} = doodBlockConfig(
  {
    name: "Pay at table - Choose amount page",
    internal_name: "Pay at table - Choose amount page",
    url: "choose-amount",
    defaultParent: [/^Main Layout$/i],
    componentType: 'PatChooseAmountPageComponent',
    category: 'pay_at_table',
    description: "Pay at table - Choose amount page.",
    keywords: [],
    isRootBlock: true,
    sharedFields: {}
  },

  () => ({
    tip_amounts: {
      choice1Amount: propertyValue({
        type: 'number',
        value: 0,
        options: {
          label: "pages.blocks.pat-choose-amount-page.amount.label",
          placeholder: "1",
        }
      }),
      choice1Unit: propertyValue({
        type: 'select',
        value: "currency",
        options: {
          label: "pages.blocks.pat-choose-amount-page.unit.label",
          multiple: false,
          choices: [...tipUnitChoices],
        }
      }),
      choice2Amount: propertyValue({
        type: 'number',
        value: 0,
        options: {
          label: "pages.blocks.pat-choose-amount-page.amount.label",
        }
      }),
      choice2Unit: propertyValue({
        type: 'select',
        value: "currency",
        options: {
          label: "pages.blocks.pat-choose-amount-page.unit.label",
          multiple: false,
          choices: [...tipUnitChoices],
        }
      }),
      choice3Amount: propertyValue({
        type: 'number',
        value: 0,
        options: {
          label: "pages.blocks.pat-choose-amount-page.amount.label",
          placeholder: "5",
        }
      }),
      choice3Unit: propertyValue({
        type: 'select',
        value: "currency",
        options: {
          label: "pages.blocks.pat-choose-amount-page.unit.label",
          multiple: false,
          choices: [...tipUnitChoices],
        }
      })
    }
  }),

  () => ({
    tabs: [
      {
        label: "pages.blocks.pat-choose-amount-page.tab.content.label",
        fieldsets: [
          {
            legend: "pages.blocks.pat-choose-amount-page.fieldset.choice-1.label",
            fields: ["tip_amounts.choice1Amount", "tip_amounts.choice1Unit"],
          },
          {
            legend: "pages.blocks.pat-choose-amount-page.fieldset.choice-2.label",
            fields: ["tip_amounts.choice2Amount", "tip_amounts.choice2Unit"],
          },
          {
            legend: "pages.blocks.pat-choose-amount-page.fieldset.choice-3.label",
            fields: ["tip_amounts.choice3Amount", "tip_amounts.choice3Unit"],
          },
        ],
      },
    ],
  })
);

export function patChooseAmountPageDescriptor(): IBlockDescriptor;
export function patChooseAmountPageDescriptor(
  fieldOrder: readonly DescriptorFieldOrderItem[],
): IBlockDescriptor;
export function patChooseAmountPageDescriptor(
  fieldOrder?: readonly DescriptorFieldOrderItem[],
): IBlockDescriptor {
  if (fieldOrder === undefined) {
    return _generatedPatChooseAmountPageDescriptor;
  }
  return buildOrderedBlockDescriptor(_generatedPatChooseAmountPageDescriptor, patChooseAmountPageProperties, fieldOrder);
}

export {
  patChooseAmountPageBlocDefinition,
  patChooseAmountPageDashboardLayout,
  patChooseAmountPageProperties,
  patChooseAmountPageConfig,
  patChooseAmountPageResolveConfig,
};

export type PatChooseAmountPageConfig = typeof patChooseAmountPageConfig;
